import { render, staticRenderFns } from "./GrowUp2.vue?vue&type=template&id=db09710c&scoped=true&"
import script from "./GrowUp2.vue?vue&type=script&lang=js&"
export * from "./GrowUp2.vue?vue&type=script&lang=js&"
import style0 from "./GrowUp2.vue?vue&type=style&index=0&id=db09710c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db09710c",
  null
  
)

export default component.exports